module.exports = __webpack_public_path__ + "img/06.92e33930.jpg";